
import { Heading1, Heading2, Heading3 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Editor } from '@tiptap/react';

export default function HeadingButtons({ editor }: { editor: Editor }) {
  return (
    <>
      <Button
        size="icon"
        variant={editor.isActive('heading', { level: 1 }) ? 'secondary' : 'ghost'}
        onClick={e => {
          e.preventDefault();
          editor.chain().focus().toggleHeading({ level: 1 }).run();
        }}
        className="h-8 w-8"
        title="Heading 1"
        type="button"
      >
        <Heading1 className="h-4 w-4" />
      </Button>
      <Button
        size="icon"
        variant={editor.isActive('heading', { level: 2 }) ? 'secondary' : 'ghost'}
        onClick={e => {
          e.preventDefault();
          editor.chain().focus().toggleHeading({ level: 2 }).run();
        }}
        className="h-8 w-8"
        title="Heading 2"
        type="button"
      >
        <Heading2 className="h-4 w-4" />
      </Button>
      <Button
        size="icon"
        variant={editor.isActive('heading', { level: 3 }) ? 'secondary' : 'ghost'}
        onClick={e => {
          e.preventDefault();
          editor.chain().focus().toggleHeading({ level: 3 }).run();
        }}
        className="h-8 w-8"
        title="Heading 3"
        type="button"
      >
        <Heading3 className="h-4 w-4" />
      </Button>
    </>
  );
}
